import { Pipe, PipeTransform } from '@angular/core';
import { Dokument } from '../models/dokument';
import { ApplicationCode } from '../enums/application_code';
import { InboxType } from '../enums/inbox-type.enum';

@Pipe({
  name: 'shouldShowCorrespondenceIcon',
  standalone: true,
  pure: true,
})
export class ShouldShowCorrespondenceIconPipe implements PipeTransform {
  transform(
    dokument: Dokument | null | undefined,
    inboxType: InboxType | null | undefined,
  ): boolean {
    if (!dokument || inboxType == null) {
      return false;
    }

    const kod = dokument?.typDokumentu?.kod;

    if (!kod || !(Object.values(ApplicationCode) as string[]).includes(kod)) {
      return false;
    }

    /*const isDefined = ALL_APPLICATIONS_FLAT.some((app) => app.kod === kod);
    if (!isDefined) {
      return false;
    }*/

    return (
      inboxType !== InboxType.ARCHIVED &&
      !!dokument?.typDokumentu?.czyKorespondencjaAktywna
    );
  }
}
